module.exports = __webpack_public_path__ + "img/mobp.56322740.png";